<template>
	<div>
		<hr style="margin-top: 1.5rem; margin-bottom: 2.5rem;" />

		<Row v-if="spec" class="d-flex flex-wrap" :gutter="16">
			<Col
				v-for="(stage, ind) in rounds.filter((round) => round.category === $route.params.cat && !round.isPlayoff)"
				span="8"
				class="mb-3"
				:key="stage._id + ind"
			>
				<Card v-if="matches.filter((match) => match.round._id === stage._id).length" class="tournament-stage table-card-style">
					<table class="match-table table-margin">
						<thead>
							<tr class="first-table-row">
								<th>
									<h3>{{ stage.name }}</h3>
								</th>
								<th class="w-70px"></th>
							</tr>
							<tr>
								<th>{{ $t('competition.match') }}</th>
								<th>{{ $t('competition.score') }}</th>
							</tr>
						</thead>
					</table>
					<template v-for="match in matches.filter((match) => match.round._id === stage._id)">
						<table :key="match._id" class="match-table table-margin position-relative">
							<tbody>
								<tr
									:class="`${
										getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team)
											? 'font-weight-bold first-table-row'
											: 'first-table-row'
									}`"
								>
									<td>
										<Tooltip :content="match.home_team.name" placement="top-start" class="w-100">
											<span class="text-overflow-style rounds-clamt-text">{{ match.home_team.name }}</span>
										</Tooltip>
									</td>
									<td class="w-70px position-relative">
										<span v-if="matches.length">
											{{ getPoints(match.home_players, match, match.home_team) }}
										</span>
										<Icon v-if="match.stage.rounds.length > 0" role="button" type="md-information-circle" class="icon-pos" @click="() => openModal(match)" />
									</td>
								</tr>
								<tr
									:class="`${
										getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
									}`"
								>
									<td>
										<Tooltip :content="match.away_team.name" placement="top-start" class="w-100">
											<span class="text-overflow-style rounds-clamt-text">{{ match.away_team.name }}</span>
										</Tooltip>
									</td>
									<td class="w-70px position-relative">
										<span v-if="matches.length">
											{{ getPoints(match.away_players, match, match.away_team) }}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</template>
				</Card>
			</Col>
		</Row>
	</div>
</template>

<script>
	import storeMixin from '../storeMixin';

	export default {
		name: 'RoundsBlock',
		components: {},
		data() {
			return storeMixin;
		},
	};
</script>

<style scoped>
.rounds-clamt-text {
	width: 100%;
}

table {
	table-layout: fixed;
}
.w-70px {
	width: 70px;
	min-width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/groups/RoundsBlock.vue